import React from "react";
import Markdown from "react-markdown";
import { rehypeGithubAlerts } from "rehype-github-alerts";
import remarkGfm from "remark-gfm";
import remarkMermaid from "remark-mermaidjs";
import admonitionOptions from "./admonition";
import SyntaxHighlighter from "react-syntax-highlighter";

export type MarkdownViewProps = {
  displayedMarkdown: string;
};

const MarkdownView = ({
  displayedMarkdown,
}: MarkdownViewProps): JSX.Element => {
  return (
    <Markdown
      remarkPlugins={[remarkGfm, remarkMermaid]}
      rehypePlugins={[[rehypeGithubAlerts, admonitionOptions]]}
      remarkRehypeOptions={{
        allowDangerousHtml: true,
      }}
      children={displayedMarkdown}
      components={{
        code(props) {
          const { children, className, node, ...rest } = props;
          const match = /language-(\w+)/.exec(className || "");
          return match ? (
            <SyntaxHighlighter
              PreTag="div"
              children={String(children).replace(/\n$/, "")}
              language={match[1]}
            />
          ) : (
            <code {...rest} className={className}>
              {children}
            </code>
          );
        },
        h1({ node, children, ...props }: any) {
          return (
            <h1 id={node.children[0].value} {...props}>
              {children}
            </h1>
          );
        },
        h2({ node, children, ...props }: any) {
          return (
            <h2 id={node.children[0].value} {...props}>
              {children}
            </h2>
          );
        },
        h3({ node, children, ...props }: any) {
          return (
            <h3 id={node.children[0].value} {...props}>
              {children}
            </h3>
          );
        },
        h4({ node, children, ...props }: any) {
          return (
            <h4 id={node.children[0].value} {...props}>
              {children}
            </h4>
          );
        },
        h5({ node, children, ...props }: any) {
          return (
            <h5 id={node.children[0].value} {...props}>
              {children}
            </h5>
          );
        },
        h6({ node, children, ...props }: any) {
          return (
            <h6 id={node.children[0].value} {...props}>
              {children}
            </h6>
          );
        },
      }}
    />
  );
};

export default MarkdownView;
